var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4 2a2 2 0 00-2-2h-.8a2 2 0 00-2 2v5.6a2 2 0 01-2 2H2a2 2 0 00-2 2v.8a2 2 0 002 2h5.6a2 2 0 012 2V22a2 2 0 002 2h.8a2 2 0 002-2v-5.6a2 2 0 012-2H22a2 2 0 002-2v-.8a2 2 0 00-2-2h-5.6a2 2 0 01-2-2V2z",
    fill: "#9C7D3E"
  })));
}
export default SvgCrossinline;